import { useSplitClient } from '@splitsoftware/splitio-react';

const useIsConciergeEnabled = (options) => {
    var _a;
    const splitIO = useSplitClient();
    const conciergeTreatment = (_a = splitIO.client) === null || _a === void 0 ? void 0 : _a.getTreatment('brandclub_concierge', {
        email: (options === null || options === void 0 ? void 0 : options.email) || ''
    });
    return conciergeTreatment === 'on' || window.location.host.includes('localhost');
};

export { useIsConciergeEnabled };
//# sourceMappingURL=useIsConciergeEnabled.js.map
